
<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.partner', 2) }}
                    </h3>
                </div>
            </div>

            <div class="">
                <div class="card-title ml-3">
                    <router-link :to="{ name: 'add-partner' }" v-if="can || hasPraticienRole || hasMedecinControleRole || hasAssistante">
                        {{ $t('message.add') }}

                        <i class="fas fa-plus-circle edit-icon"></i>
                    </router-link>
                </div>
                <b-container class="">
                    <b-row v-if="notEmpty(mPartners)">
                        <b-col col sm="12">
                                    <section class="" id="appointment-table">
                                        <div class="appointment-table-header my-2 mb-4">
                                            <div class="row">
                                                <div class="col-12">
                                                    <b-input-group
                                                            class="mb-3"
                                                    >
                                                        <b-form-input
                                                                type="text"
                                                                class="p-2"
                                                                :placeholder="$t('message.search') + '...'"
                                                                v-model.lazy="filterCriteria"
                                                        ></b-form-input>
                                                        <b-input-group-append>
                                                            <b-button
                                                                    size="sm"
                                                                    text="Button"
                                                                    variant="primary"
                                                                    @click="handlerOnFilterButton"
                                                            >
                                                                Go
                                                            </b-button>
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-3">
                                                    <div class="ml-1">
                                                        <div class="d-flex">
                                                            <b-form-select
                                                                    class="d-inline-block mr-2"
                                                                    v-model="sortSelected"
                                                                    size="sm"
                                                                    :options="sortOptions"></b-form-select>

                                                            <div>
                                                                <b-button-group size="sm" class="mr-1">
                                                                    <b-button
                                                                            :disabled="sortDirection === 'asc'"
                                                                            class="btn"
                                                                            size="sm"
                                                                            @click="sortDirection='asc'"
                                                                    >
                                                                        <i class="fa fa-sort-amount-up-alt"></i>
                                                                    </b-button>
                                                                    <b-button
                                                                            :disabled="sortDirection === 'desc'"
                                                                            class="btn"
                                                                            size="sm"
                                                                            @click="sortDirection='desc'"
                                                                    >
                                                                        <i class="fa fa-sort-amount-down-alt"></i>
                                                                    </b-button>
                                                                </b-button-group>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="paginationObject.numOfPages > 1" class="col-3 pagination-wrapper d-inline-block">
                                <div class="pagination">
                                    <a
                                        href="#"
                                        :class="'prev page-numbers ' + (
                                                                    paginationObject.currentPageNumber === 1
                                                                        ? 'pagination-disabled'
                                                                        : ''
                                                                    )"
                                        @click="_handlePaginationClick('prev')"
                                    >
                                    <i aria-hidden="true" class="v-icon fas fa-chevron-left"></i>
                                    </a>
                                    <template v-for="(pageNumber, key) in paginationObject.listOfPageNumber()">
                                    <template v-if="pageNumber === paginationObject.currentPageNumber">
                                                                        <span
                                                                            :key="key"
                                                                            aria-current="page"
                                                                            class="page-numbers current"
                                                                        >
                                                                            {{ pageNumber }}
                                                                        </span>
                                    </template>
                                    <template v-else>
                                        <a
                                            href="#"
                                            :key="key"
                                            class="page-numbers"
                                            @click="_handlePaginationClick(pageNumber)"
                                        >
                                        {{ pageNumber }}
                                        </a>
                                    </template>
                                    </template>
                                    <a
                                        href="#"
                                        class="next page-numbers"
                                        :class="'next page-numbers ' + (
                                                                    paginationObject.currentPageNumber === paginationObject.numOfPages
                                                                        ? 'pagination-disabled'
                                                                        : ''
                                                                    )"
                                        @click="_handlePaginationClick('next')"
                                    >
                                    <i aria-hidden="true" class="v-icon fas fa-chevron-right"></i>
                                    </a>
                                </div>
                                </div>
                                            </div>

                                        </div>

                                        <div class="row appointment-table-content">
                                            <div class="container-fluid">
                                                <template
                                                        v-if="hasValue(paginationObject.display(paginationObject.currentPageNumber) )"
                                                >
                                                    <div
                                                            v-for="(mPartner, key) in paginationObject.display(paginationObject.currentPageNumber)"
                                                            :key="key"
                                                            class="row appointment-item hovered"
                                                            @click="mPartnerClick(mPartner.slug)"
                                                    >
                                                        <div class="col-lg-3">
                                                                <span class="appointment-label">
                                                                    {{ $tc('message.region', 1) }}
                                                                </span>
                                                            <h4 class="appointment-date">{{ mPartner.region }}</h4>
                                                        </div>
                                                        <div class="col-lg-3">
                                                                <span class="appointment-label">
                                                                    {{ $t('message.cities') }}
                                                                </span>
                                                            <h4 class="appointment-hour">
                                                                {{ mPartner.ville }}
                                                            </h4>
                                                        </div>
                                                        <div class="col-lg-3">
                                                                <span class="appointment-label">
                                                                    {{ $t('message.address') }}
                                                                </span>
                                                            <h4 class="appointment-hour">
                                                                {{ mPartner.localisation }}
                                                            </h4>
                                                        </div>
                                                        <div class="col-lg-3">
                                                                <span class="appointment-label">
                                                                    {{ $t('message.email') }}
                                                                </span>
                                                            <h4 class="appointment-hour">
                                                                {{ mPartner.email }}
                                                            </h4>
                                                        </div>
                                                        <div class="col-lg-3">
                                                                <span class="appointment-label">
                                                                    {{ $t('message.personContact') }}
                                                                </span>
                                                            <h4 class="appointment-hour">
                                                                {{ mPartner.nom }}
                                                            </h4>
                                                        </div>
                                                        <div class="col-lg-3">
                                                                <span class="appointment-label">
                                                                    {{ $t('message.phoneNumber') }}
                                                                </span>
                                                            <h4 class="appointment-hour">
                                                                {{ mPartner.telephone }}
                                                            </h4>
                                                        </div>
                                                    </div>
                                                </template>

                                                <template v-else>
                                                    <h4>{{ $t('message.noItemToDisplay') }}</h4>
                                                </template>

                                            </div>
                                        </div>
                                    </section>
                             
                        </b-col>
                    </b-row>
                </b-container>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import _ from 'lodash';
    import { ModelSelect } from 'vue-search-select';
    import Swal from 'sweetalert2';
    //import {pagination, handlePaginationClick, paginationDataProperty} from "../../helpers/paginations2";
    export default {
        name: "Partners",

        computed: {
            ...mapGetters(["Partners",'hasAdminRole',
                'hasGestionnaireRole','hasMedecinControleRole','hasAssistante']),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasMedecinControleRole || this.hasAssistante;
            },

            mPartners: function() {
                let pArray = [];
                //  console.log(this.Partners);
                _.forEach(_.orderBy(this.Partners,['created_at'],['desc']), function(partner) {
                    let p = {};
                    
                    if(!_.isNull(partner )){
                        p.region =  (partner.region).toUpperCase();
                        p.email = partner.email;
                        p.telephone = partner.telephone;
                        p.slug = partner.slug;
                        p.nom = partner.nom;
                        p.ville = partner.ville;
                        p.contact = partner.contact;
                        p.localisation = partner.localisation;
                    }
                    pArray.push(p);
                });
                
                
                return _.sortBy(pArray,['region']);
            },

            rows: function() {
                return this.mPartners.length;
            },
            
            /*options:function(){
                let oArray = [];

                _.forEach(this.mInstitutions, function (institution) {
                    oArray.push({value:institution.etablissementId, text:  institution.nom});
                })  ;
                oArray.push({value:'0',text:'All'});
                return oArray;
            },**/
        },
        
        components: {
            ModelSelect
        },
        watch:{

            searchTerm:function (newValue, oldValue) {
                if(typeof(newValue) != 'undefined'){
                        if (newValue.trim().length ==0){
                        this.partnerPeInstitutionsRowsFilter = [];
                    } else{
                    this.partnerPeInstitutionsRowsFilter = this.mPartners;
                    }
                }
            },

             mPartners: function (newValue, oldValue) {
                this.paginationObject = this.Pagination(newValue, 10);
                if (!this.shouldDisplay) {
					this.currentPartnerArray = [];
					this.currentPartnerArrayFiltered = [];
				} else {
					this.currentPartnerArray = [...this.mPartners];
					this.currentPartnerArrayFiltered = this.currentPartnerArray;
				}
                },

			Partners: function (newValue, oldValue) {
				if (!this.shouldDisplay) {
					this.currentPartnerArray = [];
					this.currentPartnerArrayFiltered = [];
				} else {
					this.currentPartnerArray = [...this.mPartners];
					this.currentPartnerArrayFiltered = this.currentPartnerArray;
				}
			},

			currentPartnerArray: function (newValue, oldValue) {
				this.paginationObject = pagination(newValue);
			},

			filterCriteria: function (newValue, oldValue) {
                if (newValue.length !== 0) {
					this.shouldDisplay = true;
					this.handleFilter(newValue);
				} else this.shouldDisplay = false;
               // this.handleFilter(newValue);
            },

			sortDirection: function (newValue, oldValue) {
                
                                if (newValue.length !== 0) {
					this.shouldDisplay = true;
					this.handleSort(this.sortSelected ,newValue);
				} else this.shouldDisplay = false;
			},

			sortSelected: function (newValue, oldValue) {
               
                if (newValue.length !== 0) {
					this.shouldDisplay = true;
					 this.handleSort(newValue, this.sortDirection);
				} else this.shouldDisplay = false;
			},

			shouldDisplay: function (newValue, oldValue) {
                // console.log(this.mPartners)
				if (newValue) {
					this.currentPartnerArray = [...this.mPartners];
					this.currentPartnerArrayFiltered = this.currentPartnerArray;
				} else {
					this.currentPartnerArray = [];
					this.currentPartnerArrayFiltered = [];
                }
                
			}
        },
        data() {
            return {
                //...paginationDataProperty(this.$i18n),
                filterCriteria: '',
				shouldDisplay: false,
                sortDirection: 'asc',
                sortSelected: null,
                mPartnersFilter:[],
                searchTerm : '',
                paginationObject: {},

                item: {
                    value: '',
                    text: ''
                },

                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },
                sort: {
                    enabled: true,
                    initialSortBy: {field: 'region', type: 'desc'}
                },
                sortOptions: [
                    { value: null, text: this.$i18n.t('message.sortBy'), disabled: true },
                    { value: 'region', text: this.$i18n.tc('message.region', 1) },
                    { value: 'ville', text: this.$i18n.tc('message.cities',1) },
                    { value: 'nom', text: this.$i18n.t('message.partner') },
                    { value: 'contact', text: this.$i18n.t('message.personContact') },
                ],
                enabled: {enabled: true},
                            
                mPartnersColumns: [
                    {
                        field: 'region',
                        label: this.$i18n.t('message.region'),
                    },
                    {
                        field: 'ville',
                        label: this.$i18n.tc('message.cities',1),
                    },
                    {
                        field: 'nom',
                        label: this.$i18n.t('message.partner'),
                    },
                    {
                        field: 'localisation',
                        label: this.$i18n.t('message.address'),
                    },
                    {
                        field: 'telephone',
                        label: this.$i18n.t('message.phoneNumber'),
                    },
                                        {
                        field: 'email',
                        label: this.$i18n.t('message.email'),
                    },
                    {
                        field: 'contact',
                        label: this.$i18n.t('message.personContact'),
                    },
                ],
                offset: 0,
                limit: -1,
            }
            
        },

        methods: {
            hasValue(item){
                    if(typeof(item) != 'undefined')
                    return item.length > 0;
                    return false;
            },

            Pagination(pageEleArr, numOfEleToDisplayPerPage) {
      // Create an object to easily manipulate property linked
      const result = {};
      // Added a new property to hold the list of elements
      result.pageEleArr = pageEleArr;

      // Added a new property to hold the number of item to display per page
      result.numOfEleToDisplayPerPage = numOfEleToDisplayPerPage;

      // Added a new property to hold the total number of items
      result.elementCount = result.pageEleArr.length;

      // Added a new property to hold the number of items to display per page
      result.numOfPages = Math.ceil(result.elementCount / result.numOfEleToDisplayPerPage);

      // Set the current page number to 1
      result.currentPageNumber = 1;

      result.listOfPageNumber = function () {
        const listOfPageNumber = [];
        for (let i = 1; i < result.numOfPages + 1; i++) {
          listOfPageNumber.push(i);
        }
        return listOfPageNumber;
      };

      // Function to get the various list item per page
      // Return Array[Array]
      const pageElementsArr = function (arr, eleDispCount) {
        const arrLen = arr.length;
        const noOfPages = Math.ceil(arrLen / eleDispCount);
        const pageArr = [];

        let perPageArr = [], index = 0, condition = 0, remainingEleInArr = 0;

        for (let i = 0; i < noOfPages; i++) {
          if (i === 0) {
            index = 0;
            condition = eleDispCount;
          }
          // Create an list of items of a page
          for (let j = index; j < condition && j < arrLen; j++) {
            perPageArr.push(arr[j]);
          }

          // insert that list into then global list
          pageArr.push(perPageArr);

          if (i === 0) {
            remainingEleInArr = arrLen - perPageArr.length;
          } else {
            remainingEleInArr = remainingEleInArr - perPageArr.length;
          }

          if (remainingEleInArr > 0) {
            if (remainingEleInArr > eleDispCount) {
              index = index + eleDispCount;
              condition = condition + eleDispCount;
            } else {
              index = index + perPageArr.length;
              condition = condition + remainingEleInArr;
            }
          }
          perPageArr = [];
        }
        return pageArr;
      };

      // Main method to get a list of a particular page
      result.display = function (pageNo) {
        // If the asked page is not in the range of available pages
        if (pageNo > result.numOfPages || pageNo <= 0) {
          return [];
        } else {
          // Get the total list
          const totalList = pageElementsArr(result.pageEleArr, result.numOfEleToDisplayPerPage);

          // Return the list of the pageNo
          return totalList[[pageNo - 1]];
        }
      };

      // Return the pagination object
      return result;
    },

            getPartners() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getPartners', { args : args });
            },
            notEmpty(item){
                // console.log(item.length);
                return item.length > 0;
            },
            mPartnerClick(slug) {
                this.$router.push({ name: 'partner', params: { partner: slug } });
            },

            deletePartner(partner) {
                let self = this;

                let args = {
                    partner: partner
                };

                let successMessage = this.$i18n.t('message.partnerDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deletePartner', { args, index: partner, successMessage, errorMessages })
                    .then(() => {
                        self.$bvModal.hide('delete-modal-' + partner);
                    });
            },
        
			handlerOnFilterButton() {
				event.preventDefault();
				this.handleFilter(this.filterCriteria);
			},

			_handlePaginationClick(action) {
				this.paginationObject = this.handlePaginationClick(action, {...this.paginationObject});
			},
            handlePaginationClick(action, paginationObject) {
                // If we want to go to the previous page
                if (action === 'prev') {
                    if (paginationObject.currentPageNumber - 1 >= 1)
                        paginationObject.currentPageNumber = paginationObject.currentPageNumber - 1;
                }

                // If we want to go to the next page
                else if (action === 'next') {
                    if (paginationObject.currentPageNumber + 1 <= paginationObject.numOfPages)
                        paginationObject.currentPageNumber = paginationObject.currentPageNumber + 1;
                }

                // If we want to go to a particular page
                else {
                    const numberOfPageToGoTo = Number(action);
                    if (numberOfPageToGoTo <= paginationObject.numOfPages &&
                        numberOfPageToGoTo >= 1
                    ) paginationObject.currentPageNumber = numberOfPageToGoTo;
                }

                return paginationObject;
            },
			handleFilter(value) {
				if (value) {
					const newCurrentPartnerArray = this.mPartners.filter(app => {
						let result = false;

						if (app.nom) {
							result = result || app.nom.toLowerCase().includes(value.toLowerCase());
						}

						if (app.ville) {
							result = result || app.ville.toString().toLowerCase().includes(value.toLowerCase());
						}

						if (app.region) {
							result = result || app.region.toString().toLowerCase().includes(value.toLowerCase());
						}

						if (app.email) {
							result = result || app.email.toLowerCase().includes(value.toLowerCase());
						}

						return result;
					});

					
					this.paginationObject = this.Pagination(newCurrentPartnerArray,2);
				} else {
					
					this.paginationObject = this.Pagination(this.mPartners,2);
				}
			},

			handleSort(value, sortDirection = 'asc') {
				if (value) {
                   
	     			let newCurrentPartnerArray = [];
					const sortType = ['nom', 'region', 'ville', 'email'];
					const restOfType = sortType.filter(i => i !== value);
                    
					const sortDirectionType = ['asc', 'desc'];
					const restOfSortDirectionType = sortDirectionType.filter(i => i !== sortDirection);

					newCurrentPartnerArray = _.orderBy(this.mPartners, [value, ...restOfType], [sortDirection, ...restOfSortDirectionType]);
                    // console.log(newCurrentPartnerArray);
					this.paginationObject = this.Pagination(newCurrentPartnerArray,2);
				} else {
					this.paginationObject = this.Pagination(this.mPartners,2);
                }
            }
			},
            mounted() {
                // Fetch partner list
                this.getPartners();
            }
    }
</script>

<style scoped>

</style>